/*
 *@Author: 王伟东
 *@Date: 2021-06-29 11:48:34
 *@Description: 聊天mqtt互发消息层
*/
import webChat from "./webEachChat"; // 开始聊天的初始化video的代码
let _vue = {};
let _init = false; // 是否初始化过
let callbackFn = function (msg) {
  _vue.$bus.$emit("videoCallback", msg)
}
// 本地流和远端流
let localStreamObj;
let selfDeviceId; // 自己的设备id
let status = 0; // 通话状态  0 代表空闲  1 代表呼叫中/接听中 2 通话中
let interval = null; // 定时器
let calledList = []; // 被呼叫方的列表 在呼叫方收到__inviteRing使用
function VideoChat(options) {

  if (this._isinit) {
    return window.VideoChatEle;// 在第一次调用视频聊天实例化videoChat的时候需要将实例化赋值给window.VideoChatEle上，保障下次实例化后返回的是同一个变量
  }
  if (!options) {
    return;
  }
  _vue = options.vueThis;
  this.options = options;
  if (!_vue) {
    console.error("请传入vue实例vueThis属性");
    return;
  }
  setDeviceId(options); // 设置自己的设备id
  calledList = []; //让被呼叫放的数据列表清空
  localStorage.removeItem("roomInfo"); // 每次发起视频聊天前先把房间号清除掉 一次只能一个聊天 一个房间号
  this._init(options);
  status = 1; // 呼叫中
  this._isinit = true;
}
// 设置设备id
function setDeviceId(options) {
  var deviceName = "";
  var userAgentInfo = window.navigator.appVersion;
  if (window.AppInterace) { // 代表在移动端
    deviceName = _vue.$tu.judgeEnviroment();
  } else { // 代表在android h5页面
    var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
    for (var i = 0; i < Agents.length; i++) {
      if (userAgentInfo.indexOf(Agents[i]) != -1) {
        deviceName = "h5web";
        break;
      } else if (i == Agents.length - 1) {
        deviceName = "pcweb";
      }
    }
  }
  // 自己的设备id
  selfDeviceId = options.selfId + "-" + deviceName + "-" + _vue.$tu.createRandom();
}
// 关闭连接
function closeConnect(msg,refuseType) {
  
  for (var i = 0; i < calledList.length; i++) {
    
    if (msg.messageString.inviteDeviceId != calledList[i].inviteDeviceId || calledList[i].confirmDeviceId != msg.messageString.confirmDeviceId) {
      window.videoChatCallback({
        event: "__received_on_other_devices",
        userId: calledList[i].confirmID,
        inviteID: calledList[i].inviteID,
        confirmID: calledList[i].confirmID,
        confirmName: calledList[i].confirmName,
        room: calledList[i].room,
        refuseType: refuseType?refuseType:0,
        inviteDeviceId: calledList[i].inviteDeviceId,
        confirmDeviceId: calledList[i].confirmDeviceId
      });
    }
  }
}
VideoChat.close = function () {
  localStreamObj.close();
}
VideoChat.muted = function (type) {
  localStreamObj.muted(type);
}
// 发起视频聊天
VideoChat.prototype._init = function (options) {
  var randomRoom = _vue.$tu.createRandom();
  var roomInfo = localStorage.getItem("roomInfo") ? JSON.parse(localStorage.getItem("roomInfo")) : {};
  roomInfo[randomRoom] = { // 存储room的id
    confirmID: options.touserID, // 被呼叫用户chatid,
    confirmName: options.tousername, // 被呼叫用户名,
    confirmLogo: options.touserLogo, // 被呼叫方头像
    room: randomRoom, // room
    isActive: false, // 当前是否正在视频聊天
    inviteID: options.selfId, // 呼叫方chatid
    inviteNAME: options.selfName, // 呼叫方名称
    inviteLogo: options.selfLogo,// 呼叫方头像
    inviteDeviceId: selfDeviceId, // 呼叫方设备id
    confirmDeviceId: "" // 被呼叫方设备id
  };
  localStorage.setItem("roomInfo", JSON.stringify(roomInfo));
  // 调壳发起视频聊天
  // var state = _vue.$tu.appInterFace("voip_invite", {
  //   touserID: options.touserID, // 被呼叫用户chatid,
  //   tousername: options.tousername, // 被呼叫用户名,
  //   room: randomRoom,
  //   audioOnly: false// 是否仅音频，false为视频，true为音频
  // });
  localStreamObj = webChat.localVideoFn({
    confirmID: options.touserID, // 被呼叫用户chatid,
    confirmName: options.tousername, // 被呼叫用户名,
    confirmLogo: options.touserLogo, // 被呼叫方头像
    inviteID: options.selfId, // 呼叫方chatid
    inviteNAME: options.selfName, // 呼叫方名称
    inviteLogo: options.selfLogo,// 呼叫方头像
    room: randomRoom,
    audioOnly: false,// 是否仅音频，false为视频，true为音频
    remoteVideo: _vue.$refs.remoteVideo,
    localVideo: _vue.$refs.localVideo,
    _vue: _vue
  });
  // 生成mqtt对象
  const sendPlayload = new _vue.$mqtt.xyjPayload({
    topic: _vue.$topic.$IMNEWS, // + this.rowData.userId,
    messageType: 1029,
    eventName: "__invite",
    toUserId: options.touserID, // 被呼叫用户chatid,
    messageString: {
      inviteID: options.selfId, // 呼叫用户chatid,
      inviteNAME: options.selfName,
      inviteDeviceId: selfDeviceId, // 呼叫方设备id
      audioOnly: options.audioOnly,
      room: randomRoom,
      confirmID: options.touserID, // 被呼叫用户chatid,
      confirmName: options.tousername, // 被呼叫用户名,
    },
    qos: 0
  });
  _vue.$mqtt.send(sendPlayload);
};

// 呼叫方正在呼叫 需要响应进行响铃操作
function receivedCall(msg) {
  var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  setDeviceId({ selfId: userInfo.chatid }); // 设置当前设备id
  localStorage.removeItem("roomInfo"); // 每次发起视频聊天前先把房间号清除掉 一次只能一个聊天 一个房间号
  var roomInfo = localStorage.getItem("roomInfo") ? JSON.parse(localStorage.getItem("roomInfo")) : {};
  roomInfo[msg.messageString.room] = { // 存储room的id
    confirmID: userInfo.chatid, // 被呼叫用户chatid,
    confirmName: userInfo.empname, // 被呼叫用户名,
    confirmLogo: userInfo.empLogo, // 被呼叫头像
    room: msg.messageString.room, // room
    isActive: false, // 当前是否正在视频聊天
    inviteID: msg.messageString.inviteID, // 呼叫方的chatid
    inviteNAME: msg.messageString.inviteNAME, // 呼叫方的名称
    inviteLogo: "",// 呼叫方的头像
    inviteDeviceId: msg.messageString.inviteDeviceId, // 呼叫方设备id
    confirmDeviceId: "" // 被呼叫方设备id
  };
  localStorage.setItem("roomInfo", JSON.stringify(roomInfo));
  // 调壳发起视频聊天
  // var state = _vue.$tu.appInterFace("voip_OnInvite", {
  //   inviteID: msg.messageString.inviteID, // 呼叫用户id,
  //   inviteNAME: msg.messageString.inviteNAME, // 呼叫用户名,
  //   room: msg.messageString.room,
  //   userList: userInfo.empname,
  //   audioOnly: msg.messageString.audioOnly// 是否仅音频，false为视频，true为音频
  // });
  localStreamObj = webChat.localVideoFn({
    inviteID: msg.messageString.inviteID, // 呼叫用户id,
    inviteNAME: msg.messageString.inviteNAME, // 呼叫用户名,
    room: msg.messageString.room,
    confirmID: userInfo.chatid, // 被呼叫用户chatid,
    confirmName: userInfo.empname, // 被呼叫用户名,
    confirmLogo: userInfo.empLogo, // 被呼叫头像
    audioOnly: msg.messageString.audioOnly,// 是否仅音频，false为视频，true为音频
    remoteVideo: document.getElementById("remoteVideo"),//_vue.$refs.remoteVideo,
    localVideo: document.getElementById("localVideo"),//_vue.$refs.localVideo,
    _vue: _vue
  });
  // 生成mqtt对象
  const sendPlayload = new _vue.$mqtt.xyjPayload({
    topic: _vue.$topic.$IMNEWS, // + this.rowData.userId,
    messageType: 1030,
    eventName: "__inviteRing",
    toUserId: msg.messageString.inviteID,
    messageString: {
      inviteID: msg.messageString.inviteID,
      inviteNAME: msg.messageString.inviteNAME,
      audioOnly: msg.messageString.audioOnly,
      room: msg.messageString.room,
      confirmID: userInfo.chatid,
      inviteDeviceId: msg.messageString.inviteDeviceId, // 呼叫方设备id
      confirmDeviceId: selfDeviceId, // 被呼叫方设备id
      confirmName: userInfo.empname
    },
    qos: 0
  });
  _vue.$mqtt.send(sendPlayload);
}
// 根据InviteID获取房间信息
function getRoomDataByInviteID(inviteID) {
  var roomInfo = JSON.parse(localStorage.getItem("roomInfo"));
  for (const key in roomInfo) {
    if (roomInfo[key].inviteID == inviteID) {
      return roomInfo[key];
    }
  }
}
// 根据confirmID获取房间信息
function getRoomDataByConfirmID(confirmID) {
  var roomInfo = JSON.parse(localStorage.getItem("roomInfo"));
  for (const key in roomInfo) {
    if (roomInfo[key].confirmID == confirmID) {
      return roomInfo[key];
    }
  }
}

// 根据userId获取房间信息
function getRoomDataByUserId(userId) {
  var roomInfo = JSON.parse(localStorage.getItem("roomInfo"));
  for (const key in roomInfo) {
    if (roomInfo[key].confirmID == userId) {
      return roomInfo[key];
    } else if (roomInfo[key].inviteID == userId) {
      return roomInfo[key];
    }
  }
}
// 壳主动回调前端的函数
window.videoChatCallback = function (d) {
  const data = d;
  var roomInfo = JSON.parse(localStorage.getItem("roomInfo"));
  var roomData;
  var mqttObj = {
    topic: _vue.$topic.$IMNEWS, // + this.rowData.userId,
    messageType: "",
    eventName: "",
    toUserId: "",
    messageString: {
      inviteID: "",
      inviteNAME: "",
      audioOnly: "",
      room: "",
      confirmID: "",
      confirmName: ""
    },
    qos: 0
  };

  if (data.event == "__join") { // 接听方点击 接听时
    status = 2; // 通话中
    mqttObj.messageType = 1031;
    mqttObj.eventName = "__join";
    roomData = roomInfo[data.room];
    roomInfo[data.room].isActive = true;// 视频聊天开启
    roomInfo[data.room].confirmDeviceId = selfDeviceId; // 赋上被呼叫方设备id
    localStorage.setItem("roomInfo", JSON.stringify(roomInfo));
    mqttObj.toUserId = roomData.inviteID;
    mqttObj.messageString.inviteID = roomData.inviteID;
    mqttObj.messageString.inviteNAME = roomData.inviteNAME;
    mqttObj.messageString.audioOnly = roomData.audioOnly;
    mqttObj.messageString.room = roomData.room;
    mqttObj.messageString.confirmID = roomData.confirmID;
    mqttObj.messageString.confirmName = roomData.confirmName;
    mqttObj.messageString.inviteDeviceId = roomData.inviteDeviceId;
    mqttObj.messageString.confirmDeviceId = roomData.confirmDeviceId;
  } else if (data.event == "__offer") {
    mqttObj.messageType = 1033;
    mqttObj.eventName = "__offer";
    roomData = getRoomDataByUserId(data.userId); // 获取被呼叫方的房间信息
    mqttObj.toUserId = roomData.confirmID;
    mqttObj.messageString.inviteID = roomData.inviteID;
    mqttObj.messageString.inviteNAME = roomData.inviteNAME;
    mqttObj.messageString.audioOnly = roomData.audioOnly;
    mqttObj.messageString.room = roomData.room;
    mqttObj.messageString.confirmID = roomData.confirmID;
    mqttObj.messageString.confirmName = roomData.confirmName;
    mqttObj.messageString.sdp = data.data.sdp;
    mqttObj.messageString.inviteDeviceId = roomData.inviteDeviceId;
    mqttObj.messageString.confirmDeviceId = roomData.confirmDeviceId;
  } else if (data.event == "__answer") {
    mqttObj.messageType = 1034;
    mqttObj.eventName = "__answer";
    roomData = getRoomDataByInviteID(data.inviteID);
    mqttObj.toUserId = roomData.inviteID;
    mqttObj.messageString.inviteID = roomData.inviteID;
    mqttObj.messageString.inviteNAME = roomData.inviteNAME;
    mqttObj.messageString.audioOnly = roomData.audioOnly;
    mqttObj.messageString.room = roomData.room;
    mqttObj.messageString.confirmID = roomData.confirmID;
    mqttObj.messageString.confirmName = roomData.confirmName;
    mqttObj.messageString.sdp = data.data.sdp;
    mqttObj.messageString.inviteDeviceId = roomData.inviteDeviceId;
    mqttObj.messageString.confirmDeviceId = roomData.confirmDeviceId;
  } else if (data.event == "__ice_candidate") {
    mqttObj.messageType = 1035;
    mqttObj.eventName = "__ice_candidate";
    roomData = getRoomDataByUserId(data.userId);
    mqttObj.toUserId = sessionStorage.getItem("chatid") == roomData.inviteID ? roomData.confirmID : roomData.inviteID;
    mqttObj.messageString.inviteID = roomData.inviteID;
    mqttObj.messageString.inviteNAME = roomData.inviteNAME;
    mqttObj.messageString.audioOnly = roomData.audioOnly;
    mqttObj.messageString.room = roomData.room;
    mqttObj.messageString.confirmID = roomData.confirmID;
    mqttObj.messageString.confirmName = roomData.confirmName;
    mqttObj.messageString.id = data.data.id;
    mqttObj.messageString.label = data.data.label;
    mqttObj.messageString.candidate = data.data.candidate;
    mqttObj.messageString.inviteDeviceId = roomData.inviteDeviceId;
    mqttObj.messageString.confirmDeviceId = roomData.confirmDeviceId;
  } else if (data.event == "__reject") { // 拒接
    status = 0; // 空闲中
    mqttObj.messageType = 1036;
    mqttObj.eventName = "__reject";
    roomData = roomInfo[data.room];
    roomInfo[data.room].isActive = false;// 视频聊天结束
    localStorage.setItem("roomInfo", JSON.stringify(roomInfo));
    mqttObj.toUserId = roomData.inviteID;
    mqttObj.messageString.inviteID = roomData.inviteID;
    mqttObj.messageString.inviteNAME = roomData.inviteNAME;
    mqttObj.messageString.audioOnly = roomData.audioOnly;
    mqttObj.messageString.room = roomData.room;
    mqttObj.messageString.confirmID = roomData.confirmID;
    mqttObj.messageString.confirmName = roomData.confirmName;
    mqttObj.messageString.refuseType = data.data.refuseType;
    mqttObj.messageString.inviteDeviceId = roomData.inviteDeviceId;
    mqttObj.messageString.confirmDeviceId = selfDeviceId;
    window.VideoChatEle = null;

  } else if (data.event == "__leave") { // 通话中挂断
    status = 0; // 空闲中
    mqttObj.messageType = 1037;
    mqttObj.eventName = "__leave";
    roomData = roomInfo[data.room];
    roomInfo[data.room].isActive = false;// 视频聊天结束
    localStorage.setItem("roomInfo", JSON.stringify(roomInfo));
    mqttObj.toUserId = roomData.inviteID == data.userId ? roomData.inviteID : roomData.confirmID;
    mqttObj.messageString.inviteID = roomData.inviteID;
    mqttObj.messageString.inviteNAME = roomData.inviteNAME;
    mqttObj.messageString.audioOnly = roomData.audioOnly;
    mqttObj.messageString.room = roomData.room;
    mqttObj.messageString.confirmID = roomData.confirmID;
    mqttObj.messageString.confirmName = roomData.confirmName;
    mqttObj.messageString.inviteDeviceId = roomData.inviteDeviceId;
    mqttObj.messageString.confirmDeviceId = roomData.confirmDeviceId;
    window.VideoChatEle = null;

  } else if (data.event == "__cancel") { // 自己取消邀请
    status = 0; // 空闲中
    mqttObj.messageType = 1038;
    mqttObj.eventName = "__cancel";
    roomData = roomInfo[data.room];
    roomInfo[data.room].isActive = false;// 视频聊天结束
    localStorage.setItem("roomInfo", JSON.stringify(roomInfo));
    mqttObj.toUserId = data.userId;
    mqttObj.messageString.inviteID = roomData.inviteID;
    mqttObj.messageString.inviteNAME = roomData.inviteNAME;
    mqttObj.messageString.audioOnly = roomData.audioOnly;
    mqttObj.messageString.room = roomData.room;
    mqttObj.messageString.confirmID = roomData.confirmID;
    mqttObj.messageString.confirmName = roomData.confirmName;
    mqttObj.messageString.inviteDeviceId = roomData.inviteDeviceId;
    mqttObj.messageString.confirmDeviceId = roomData.confirmDeviceId;
    window.VideoChatEle = null;

  } else if (data.event == "__audio") { // 自己视频转语音
    mqttObj.messageType = 1039;
    mqttObj.eventName = "__audio";
    roomData = getRoomDataByUserId(data.userId);
    mqttObj.toUserId = data.userId;
    mqttObj.messageString.inviteID = roomData.inviteID;
    mqttObj.messageString.inviteNAME = roomData.inviteNAME;
    mqttObj.messageString.audioOnly = true;
    mqttObj.messageString.room = roomData.room;
    mqttObj.messageString.confirmID = roomData.confirmID;
    mqttObj.messageString.confirmName = roomData.confirmName;
    mqttObj.messageString.inviteDeviceId = roomData.inviteDeviceId;
    mqttObj.messageString.confirmDeviceId = roomData.confirmDeviceId;
  } else if (data.event == "__disconnect") { // 自己通话异常
    status = 0; // 空闲中
    mqttObj.messageType = 1040;
    mqttObj.eventName = "__disconnect";
    roomData = roomInfo[data.room];
    roomInfo[data.room].isActive = false;// 视频聊天结束
    localStorage.setItem("roomInfo", JSON.stringify(roomInfo));
    mqttObj.toUserId = data.userId;
    mqttObj.messageString.inviteID = roomData.inviteID;
    mqttObj.messageString.inviteNAME = roomData.inviteNAME;
    mqttObj.messageString.audioOnly = roomData.audioOnly;
    mqttObj.messageString.room = roomData.room;
    mqttObj.messageString.confirmID = roomData.confirmID;
    mqttObj.messageString.confirmName = roomData.confirmName;
    mqttObj.messageString.inviteDeviceId = roomData.inviteDeviceId;
    mqttObj.messageString.confirmDeviceId = roomData.confirmDeviceId;
    window.VideoChatEle = null;
  } else if (data.event == "__received_on_other_devices") { // 其它端关闭掉，只留下当前端
    mqttObj.messageType = 1041;
    mqttObj.eventName = "__received_on_other_devices";
    mqttObj.toUserId = data.userId;
    mqttObj.messageString.inviteID = data.inviteID;
    mqttObj.messageString.inviteNAME = data.inviteNAME;
    mqttObj.messageString.audioOnly = data.audioOnly;
    mqttObj.messageString.room = data.room;
    mqttObj.messageString.confirmID = data.confirmID;
    mqttObj.messageString.confirmName = data.confirmName;
    mqttObj.messageString.refuseType = data.refuseType;
    mqttObj.messageString.inviteDeviceId = data.inviteDeviceId;
    mqttObj.messageString.confirmDeviceId = data.confirmDeviceId;
  }
  mqttObj.messageString.audioOnly = mqttObj.messageString.audioOnly == undefined ? false : mqttObj.messageString.audioOnly;
  console.log("发送方",mqttObj);
  const sendPlayload = new _vue.$mqtt.xyjPayload(mqttObj);
  _vue.$mqtt.send(sendPlayload);
};
// 转换mqtt视频类型的消息，做出正确的判断，发出不同的消息类型
window.transformMqttCallback = function (msg, vueThis) {
  if (vueThis) {
    _vue = vueThis;
  }
  if (msg == "disconnected") { // 对方因为特殊情况失去链接
    status = 0;
    callbackFn({ close: true });
    return;
  }
  var roomInfo = localStorage.getItem("roomInfo") ? JSON.parse(localStorage.getItem("roomInfo")) : {};
  var obj = {
    inviteID: msg.messageString.inviteID,
    inviteNAME: msg.messageString.inviteNAME,
    audioOnly: msg.messageString.audioOnly,
    room: msg.messageString.room,
    confirmID: msg.messageString.confirmID,
    confirmName: msg.messageString.confirmName
  };
  if (status == 0 && (msg.messageType == "1029" || msg.messageType == "1038" || msg.messageType == "1040")) {
    dealMessage();
  } else if (status == 1 && (msg.messageType == "1038" || msg.messageType == "1040")) {
    dealMessage();
  } else {
    if (msg.messageString.inviteDeviceId == selfDeviceId || selfDeviceId == msg.messageString.confirmDeviceId) {
      if (!roomInfo[obj.room]) { // 房间信息不存在 就不往下走了
        return;
      }
      var cmid = roomInfo[obj.room].confirmDeviceId;
      if (status == 2 && cmid && cmid != msg.messageString.confirmDeviceId) {
        window.videoChatCallback({
          event: "__received_on_other_devices",
          userId: msg.messageString.confirmID,
          inviteID: msg.messageString.inviteID,
          confirmID: msg.messageString.confirmID,
          confirmName: msg.messageString.confirmName,
          room: msg.messageString.room,
          inviteDeviceId: msg.messageString.inviteDeviceId,
          confirmDeviceId: msg.messageString.confirmDeviceId
        });
        return;
      }
      dealMessage();
    } else {
      if ( status == 0 ) { // 不在聊天状态 不挂断
        return;
      }
      // 正在语音视频聊天 别人又跟你视频聊天 不做任何处理
      // 只有处在没有语音通话的情况下 才能接听别的语音 否则将不接听 直接挂断
      var mqttObj = {
        topic: _vue.$topic.$IMNEWS,
        messageString: {}
      };
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      mqttObj.messageType = 1036;
      mqttObj.eventName = "__reject";
      var roomData = roomInfo[obj.room]?roomInfo[obj.room]:msg.messageString;
      mqttObj.toUserId = roomData.inviteID == userInfo.chatid ? roomData.confirmID : roomData.inviteID;
      mqttObj.messageString.inviteID = roomData.inviteID;
      mqttObj.messageString.inviteNAME = roomData.inviteNAME;
      mqttObj.messageString.audioOnly = false;
      mqttObj.messageString.room = roomData.room;
      mqttObj.messageString.confirmID = userInfo.chatid;
      mqttObj.messageString.confirmName = userInfo.empname;
      mqttObj.messageString.refuseType = 0; // 0 代表忙线 1代表挂断
      mqttObj.messageString.inviteDeviceId = roomData.inviteDeviceId,
      mqttObj.messageString.confirmDeviceId = selfDeviceId;
      const sendPlayload = new _vue.$mqtt.xyjPayload(mqttObj);
      _vue.$mqtt.send(sendPlayload);
    }
  }

  function dealMessage() {
    console.log("接收方", msg);
    
    // if (msg.messageType == "1041") { // 如果是已在其它设备登录 已通话的设备不需要关闭
    //   if (msg.messageString.inviteDeviceId == invitedDid || (cfmdid && cfmdid == msg.messageString.confirmDeviceId)) { // 对方忙线
    //     window.VideoChatEle = null;
    //     callbackFn({ receivedOnOtherDevices: true });
    //     return;
    //   }
    // }
    
    if (msg.messageString.sdp && typeof msg.messageString.sdp == "string") {
      msg.messageString.sdp = {
        sdp: window.atob(msg.messageString.sdp),// 为了适应移动端
        type: msg.eventName.indexOf("offer") != -1 ? "offer" : "answer"
      }
      //msg.messageString.sdp = window.atob(msg.messageString.sdp);
    }
    if (msg.messageString.candidate && typeof msg.messageString.candidate == "string") { // 为了适应移动端
      msg.messageString.candidate = {
        candidate: msg.messageString.candidate,
        sdpMid: msg.messageString.id,
        sdpMLineIndex: msg.messageString.label
      }
      //msg.messageString.candidate = msg.messageString.candidate.candidate;
    }
    callbackFn(msg);
    if (msg.messageType == "1029") { // 呼叫方正在呼叫
      status = 1;  // 接听中
      receivedCall(msg);
    } else if (msg.messageType == "1030") { // 被呼叫方已响应 响铃了
      // _vue.$tu.appInterFace("voip_OnInviteRing", obj);
      // 可以做一些响铃操作
      calledList.push(msg.messageString);
      callbackFn({ soundOpen: true });
    } else if (msg.messageType == "1031") { // 接听方点击 接听 已同意视频邀请
      status = 2; // 通话中
      roomInfo[obj.room].confirmDeviceId = msg.messageString.confirmDeviceId;
      roomInfo[obj.room].isActive = true;// 视频聊天开启
      localStorage.setItem("roomInfo", JSON.stringify(roomInfo));
      // _vue.$tu.appInterFace("voip_onJoin", obj);
      localStreamObj.addStream();
      callbackFn({ showVideo: true });
      // 其他端需要发送消息关闭连接
      closeConnect(msg);
    } else if (msg.messageType == "1033") { // 收到sdp协商信息
      obj.sdp = msg.messageString.sdp;
      localStreamObj.answer(obj);
    } else if (msg.messageType == "1034") { // 收到answer sdp 信息
      obj.sdp = msg.messageString.sdp;
      localStreamObj.onAnswer(obj);
    } else if (msg.messageType == "1035") { // 收到 _ice_candidate 信息
      obj.id = msg.messageString.id;
      obj.candidate = msg.messageString.candidate;
      obj.label = msg.messageString.label;
      localStreamObj.addIce(msg);
    } else if (msg.messageType == "1036") { // 对方拒接
      clearInterval(interval);
      for (var x = 0;x < calledList.length;x++) {
        if (calledList[x].inviteDeviceId == msg.messageString.inviteDeviceId && calledList[x].confirmDeviceId == msg.messageString.confirmDeviceId) {
          calledList.splice(x, 1);
        }
      }
      function rejectClose() {
        status = 0;
        roomInfo[obj.room].isActive = false;// 视频聊天结束
        localStorage.setItem("roomInfo", JSON.stringify(roomInfo));
        obj.refuseType = msg.messageString.refuseType;
        window.VideoChatEle = null;
        callbackFn({ close: true });
      }
      if (msg.messageString.refuseType == 1) {
        rejectClose();
        closeConnect(msg,1);
        return;
      }
      if (calledList.length > 0) {
        return;
      }
      interval = setTimeout(() => {
        if (calledList.length > 0) {
          clearInterval(interval);
          return;
        }
        rejectClose();
      }, 5000);
        
    } else if (msg.messageType == "1037") { // 对方挂断
      status = 0;
      roomInfo[obj.room].isActive = false;// 视频聊天结束
      localStorage.setItem("roomInfo", JSON.stringify(roomInfo));
      window.VideoChatEle = null;
      callbackFn({ close: true });
    } else if (msg.messageType == "1038") { // 对方取消邀请
      status = 0;
      roomInfo[obj.room].isActive = false;// 视频聊天结束
      localStorage.setItem("roomInfo", JSON.stringify(roomInfo));
      window.VideoChatEle = null;
      callbackFn({ close: true });
      closeConnect(msg);
    } else if (msg.messageType == "1039") { // 对方视频转语音
      // TODO
    } else if (msg.messageType == "1040") { // 对方通话异常
      status = 0;
      roomInfo[obj.room].isActive = false;// 视频聊天结束
      localStorage.setItem("roomInfo", JSON.stringify(roomInfo));
      window.VideoChatEle = null;
      callbackFn({ close: true });
    } else if (msg.messageType == "1041") { // 其它端已经有建立了通讯 ，已端就不需要了 就得关掉
      status = 0;
      window.VideoChatEle = null;
      if (msg.messageString.refuseType == 0) {
        callbackFn({ receivedOnOtherDevices: true });
      } else {
        callbackFn({ close: true });
      }
    }
  }
};
export default VideoChat;



// WEBPACK FOOTER //
// ./src/components/vueChart/video/videoMqtt.js